/**
 * PNG flag URLs for consistent display across OSes (Windows often renders
 * regional-indicator emoji as two letters instead of flag images).
 */
export function getCountryFlagImageUrl(iso2: string): string {
  if (!iso2 || iso2.length !== 2) return '';
  return `https://flagcdn.com/w40/${iso2.toLowerCase()}.png`;
}
